import React from "react";
import { Box, Slider, Typography } from "@mui/material";
import { dt } from "../../../../shared/themes/redesignTokens";

interface CostSliderProps {
  value: number;
  baseValue: number;
  onChange: (adjustment: number) => void;
  label?: string;
}

const CostSlider = ({ value, baseValue, onChange, label }: CostSliderProps) => {
  const maxRange = Math.max(Math.round(baseValue * 0.2), 50);
  const step = maxRange >= 100 ? 5 : 1;

  return (
    <Box sx={{ px: 1, pt: 0.5 }}>
      {label && (
        <Typography
          sx={{
            fontFamily: dt.font,
            fontSize: "11px",
            color: dt.textSecondary,
            mb: 0.5,
          }}
        >
          {label}
        </Typography>
      )}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography
          sx={{
            fontFamily: dt.fontMono,
            fontSize: "11px",
            color: dt.textSecondary,
            minWidth: "40px",
            textAlign: "right",
          }}
        >
          -{maxRange}
        </Typography>
        <Slider
          value={value}
          min={-maxRange}
          max={maxRange}
          step={step}
          onChange={(_, newValue) => onChange(newValue as number)}
          sx={{
            color: dt.blue,
            height: 4,
            "& .MuiSlider-thumb": {
              width: 16,
              height: 16,
              backgroundColor: "#fff",
              border: `2px solid ${dt.blue}`,
              boxShadow: `0 0 0 4px ${dt.blueGlow}`,
              "&:hover, &.Mui-focusVisible": {
                boxShadow: `0 0 0 6px ${dt.blueGlow}`,
              },
            },
            "& .MuiSlider-track": {
              borderRadius: 2,
            },
            "& .MuiSlider-rail": {
              backgroundColor: "#E5E7EB",
              opacity: 1,
            },
          }}
        />
        <Typography
          sx={{
            fontFamily: dt.fontMono,
            fontSize: "11px",
            color: dt.textSecondary,
            minWidth: "40px",
          }}
        >
          +{maxRange}
        </Typography>
      </Box>
    </Box>
  );
};

export default CostSlider;
